
export const Work = () => {
  //   useLayoutEffect(() => {
  //       document.body.style.backgroundColor = "green"
  //  });
  return (
    <div>work</div>
  )
}
